import React from "react";
import {
  faMapMarkerAlt,
  // faPhoneAlt,
  faWalking,
} from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage } from "gatsby-plugin-intl";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import locationArrow from "icons/location-arrow.svg";
import { gtagsActions, gtagsCategories, gtagsSend } from "utils/gtagsUtils";

// const removeSpaces = str => String(str).replace(/\s/g, "");

const AgencyCard = ({ data, isHighlighted }) => {
  const {
    name,
    address,
    // fixNumber,
    // mobileNumber,
    distance,
    lat,
    lng,
    id,
  } = data;
  // const formattedFixNumber = removeSpaces(fixNumber);

  // const formattedMobileNumber = removeSpaces(mobileNumber);

  return (
    <div
      className={`px-6 py-4  rounded-lg mb-6 text-black ${
        isHighlighted
          ? "shadow-lg border-2 border-primary"
          : "border border-gray-200"
      }`}
      id={`agency-card-${id}`}
    >
      <div className="flex justify-between">
        <div className="w-11/12">
          <div className="mb-4 text-2xl">{name}</div>
          <div className="flex flex-col sm:flex-row justify-between">
            <div className="w-full sm:w-5/12 py-2 px-4">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="text-gray-500 mr-2"
              />
              {address}
            </div>
            {/*
            <div className="flex items-center	justify-center px-4 py-2 border-t border-b sm:border-l sm:border-r sm:border-t-0 sm:border-b-0 w-full sm:w-5/12">
              <div>
                {formattedFixNumber && formattedFixNumber !== "undefined" && (
                  <div className="text-left whitespace-no-wrap mb-1">
                    <FontAwesomeIcon
                      icon={faPhoneAlt}
                      className="text-gray-500 mr-2"
                    />
                    <a
                      className="bg-gradient-primary-2 px-2 py-1 inline-block	"
                      href={`tel:${formattedFixNumber}`}
                    >
                      {formattedFixNumber.substring(0, 4)}{" "}
                      {formattedFixNumber.substring(4, 5)}{" "}
                      {formattedFixNumber.substring(5, 7)}{" "}
                      {formattedFixNumber.substring(7, 9)}{" "}
                      {formattedFixNumber.substring(9, 11)}{" "}
                      {formattedFixNumber.substring(11, 13)}
                    </a>
                  </div>
                )}
                {formattedMobileNumber &&
                  formattedMobileNumber !== "undefined" && (
                    <div className="text-left whitespace-no-wrap">
                      <FontAwesomeIcon
                        icon={faPhoneAlt}
                        className="text-gray-500 mr-2"
                      />
                      <a
                        className="bg-gradient-primary-2 px-2 py-1 inline-block	"
                        href={`tel:${formattedMobileNumber}`}
                      >
                        {formattedMobileNumber.substring(0, 4)}{" "}
                        {formattedMobileNumber.substring(4, 5)}{" "}
                        {formattedMobileNumber.substring(5, 7)}{" "}
                        {formattedMobileNumber.substring(7, 9)}{" "}
                        {formattedMobileNumber.substring(9, 11)}{" "}
                        {formattedMobileNumber.substring(11, 13)}
                      </a>
                    </div>
                  )}
              </div>
            </div> */}
            <div className="flex py-2 w-full sm:w-2/12 px-4">
              {distance && !!lat && (
                <FontAwesomeIcon
                  icon={faWalking}
                  className="text-gray-500 mr-2"
                />
              )}
              {distance && !!lat && (
                <div className="flex rtl:flex-row-reverse">
                  <span className="mr-1">{distance[0]}</span>
                  <span className="rtl:mr-1">
                    <FormattedMessage id={`branches.${distance[1]}`} />
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-1/12 flex justify-center items-center">
          <a
            href={`https://maps.google.com/maps?q=${lat},${lng}`}
            target="_blank"
            rel="noreferrer"
            title="voir sur google maps"
            className={`${!lat && "pointer-events-none opacity-50"}`}
            onClick={() =>
              gtagsSend(gtagsCategories.SEARCH, gtagsActions.DIRECTIONS)}
          >
            <img src={locationArrow} alt="" className="" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AgencyCard;
